import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Chat from '@/components/Chat/Chat'
import CreatePublic from '@/components/Chat/CreatePublic'
import CreatePrivate from '@/components/Chat/CreatePrivate'
import Signin from '@/components/User/Signin'
import AuthGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: AuthGuard
    },
    {
      path: '/login',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/chat/:index',
      name: 'Chat',
      component: Chat,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/public',
      name: 'CreatePublicChat',
      component: CreatePublic,
      beforeEnter: AuthGuard
    },
    {
      path: '/private',
      name: 'CreatePrivateChat',
      component: CreatePrivate,
      beforeEnter: AuthGuard
    }
  ],
  mode: 'history'
})
